const addComment = require('./shipment-add-comment')

/**
 * Adds an "adjustment-reasons" comment to a shipment snapshot.
 *
 * This helper wraps the `addComment` module to attach structured
 * adjustment information—such as missing quantities or damaged units—
 * to an existing shipment snapshot.  The resulting comment document
 * will resemble:
 *
 * {
 *   "_id": "...:comment:<timestamp>",
 *   "type": "snapshot-comment",
 *   "version": "2.0.0",
 *   "createdAt": "<ISO date>",
 *   "createdBy": "<user id>",
 *   "comment": "adjustment-reasons",
 *   "adjustmentReasons": {
 *     "reasons": {
 *       "quantity_missing": 2,
 *       "units_damaged": 1,
 *       "units_with_broken_packaging": 3
 *     },
 *     "batchId": "<batch identifier>",
 *     "snapshotId": "<shipment snapshot identifier>"
 *   }
 * }
 *
 * @async
 * @function addAdjustmentReasons
 * @param {Object} state - Application state object containing user and DAL
 * @param {string} snapshotId - Unique identifier of the shipment snapshot
 * @param {string} batchId - Identifier of the product batch being adjusted
 * @param {Object<string, number>} reasons - Key/value map of adjustment reasons
 *   and their counts. Typical keys might include `quantity_missing`,
 *   `units_damaged`, or `units_with_broken_packaging`.
 * @returns {Promise<void>} Resolves when the comment has been successfully added.
 */
async function addAdjustmentReasons (state, snapshotId, batchId, reasons) {
  const adjustments = { reasons, batchId, snapshotId }

  await addComment(
    state,
    snapshotId,
    'adjustment-reasons',
    null,
    null,
    null,
    null,
    adjustments
  )
}

module.exports = addAdjustmentReasons
